import _isEqual from 'lodash/isEqual'

const isEqual_ = function (value, other, ignoreArrayOrder) {
  // use materials from https://gomakethings.com/check-if-two-arrays-or-objects-are-equal-with-javascript/

  // Get the value type
  let type = Object.prototype.toString.call(value)
  let isArray = type === '[object Array]'

  // If the two objects are not the same type, return false
  if (type !== Object.prototype.toString.call(other)) {
    return false
  }

  // If items are not an object or array, return false
  if (['[object Array]', '[object Object]'].indexOf(type) < 0) {
    return _isEqual(value, other)
  }

  // Compare the length of the length of the two items
  let valueLen = isArray ? value.length : Object.keys(value).length
  let otherLen = isArray ? other.length : Object.keys(other).length
  if (valueLen !== otherLen) {
    return false
  }

  // Compare two items
  const compare = function (item1, item2) {
    // Get the object type
    let itemType = Object.prototype.toString.call(item1)

    // If an object or array, compare recursively
    if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
      if (!isEqual_(item1, item2, ignoreArrayOrder)) {
        return false
      }
    } else {
      // Otherwise, do a simple comparison

      // If the two items are not the same type, return false
      if (itemType !== Object.prototype.toString.call(item2)) {
        return false
      }

      // Else if it's a function, convert to a string and compare
      // Otherwise, just compare
      if (itemType === '[object Function]') {
        if (item1.toString() !== item2.toString()) {
          return false
        }
      } else {
        return _isEqual(item1, item2)
      }
    }
  }

  // Compare properties
  if (isArray) {
    if (ignoreArrayOrder) {
      let otherParsedIndexes = []
      for (let i = 0; i < valueLen; i++) {
        for (let j = 0; j < valueLen; j++) {
          if (otherParsedIndexes.indexOf(j) >= 0) {
            continue
          }
          if (compare(value[i], other[j]) !== false) {
            otherParsedIndexes.push(j)
            break
          }
        }
      }
      if (otherParsedIndexes.length !== valueLen) {
        return false
      }
    } else {
      for (let i = 0; i < valueLen; i++) {
        if (compare(value[i], other[i]) === false) {
          return false
        }
      }
    }
  } else {
    for (let key in value) {
      if (value.hasOwnProperty(key)) {
        if (compare(value[key], other[key]) === false) {
          return false
        }
      }
    }
  }

  // If nothing failed, return true
  return true
}

export default function (value, other, ignoreArrayOrder) {
  return isEqual_(value, other, ignoreArrayOrder === true)
}
